registerComponent("product-blocks/product-management-letter", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * O filtro ano/mês das cartas de gestão. Sem biblioteca nenhuma: era jQuery só
 * por `.show()`/`.hide()`, `.prop('disabled')` e `.val()`.
 *
 * ── `display: 'block'`, e não `''` ─────────────────────────────────────────
 *
 * ⚠️ `.wrap-doc` e `.no-results` nascem `display: none` NA FOLHA. O `.show()`
 * do jQuery, quando o `display: ''` não bastava, caía no display padrão da tag
 * — `block`, para uma `div`. Devolver `''` aqui devolveria o `none` da folha e
 * o filtro não mostraria nada, sem erro nenhum no console. É a correção 67,
 * a mesma do `modals/modal-investir`.
 *
 * ── O acordeão que não existe mais ─────────────────────────────────────────
 *
 * O `$letterHeader.on('click', … toggleClass('active'))` já estava COMENTADO
 * no arquivo de 2020, e a folha tem `// &.active {` trocado por `& {` logo
 * abaixo: o painel fica sempre aberto e a seta do cabeçalho leva
 * `display: none`. Transposto no estado em que está — o `cursor: pointer` e o
 * `.letter-header.active` do Blade são resíduo do acordeão desligado, e mexer
 * neles mudaria a tela sem decisão do responsável. Está no relatório do 8c.
 *
 * ── O `.data('month')` do jQuery ───────────────────────────────────────────
 *
 * `data-month` vem zero-preenchido (`01`…`12`) do `format('m')`, e `data-year`
 * com quatro dígitos. O `.data()` do jQuery converteria `"10"`, `"11"` e
 * `"12"` para número e deixaria `"01"`…`"09"` como texto; como os dois usos
 * vão para um seletor de atributo, que serializa o número de volta, o
 * `dataset` cru é equivalente byte a byte. Sem `Asa.legado.dado()` aqui, de
 * propósito.
 */

const filtro = component.querySelector('.filter');

// Fundo sem carta de gestão renderiza a seção sem o `.filter` e sem o
// `.results` (o `@if(sizeof($documentos) > 0)` do Blade): sem esta saída o
// `querySelector` do `#year` devolveria `null` e o componente estouraria,
// derrubando a inicialização dos seguintes.
if (filtro) {
    const ano = filtro.querySelector('#year');
    const mes = filtro.querySelector('#month');
    const botao = filtro.querySelector('.btn');
    const semResultado = component.querySelector('.no-results');
    const cartas = Array.from(component.querySelectorAll('.wrap-doc'));

    const mostrar = (el, visivel) => {
        if (el) {
            el.style.display = visivel ? 'block' : 'none';
        }
    };

    /* ── "Buscar" ───────────────────────────────────────────────────────── */

    botao.addEventListener('click', function () {
        Asa.track('letter_filter', { filter_name: 'year_month', filter_value: `${ano.value}-${mes.value}`, method: 'search' });

        cartas.forEach((carta) => mostrar(carta, false));
        mostrar(semResultado, false);

        const achadas = cartas.filter((carta) => carta.dataset.year === ano.value
            && carta.dataset.month === mes.value);

        if (achadas.length > 0) {
            achadas.forEach((carta) => mostrar(carta, true));
        } else {
            mostrar(semResultado, true);
        }
    });

    /* ── Os meses que o ano escolhido tem ───────────────────────────────── */

    const atualizarMeses = () => {
        mes.querySelectorAll('option').forEach((opcao) => {
            opcao.disabled = true;
        });

        cartas
            .filter((carta) => carta.dataset.year === ano.value)
            .forEach((carta) => {
                const opcao = mes.querySelector(`option[value="${carta.dataset.month}"]`);

                if (opcao) {
                    opcao.disabled = false;
                }
            });
    };

    ano.addEventListener('change', atualizarMeses);

    /* ── Boot: o último ano e o último mês que ele tem ──────────────────── */

    const anos = ano.querySelectorAll('option');

    if (anos.length > 0) {
        ano.value = anos[anos.length - 1].value;
        atualizarMeses();

        const meses = mes.querySelectorAll('option:not(:disabled)');

        if (meses.length > 0) {
            mes.value = meses[meses.length - 1].value;
        }
    }

    /*
     | O boot NÃO clica no "Buscar", como em 2020: o `.trigger('change')` do
     | `#month` não tinha ouvinte nenhum. A seção abre com o filtro preenchido
     | e nenhuma carta à vista — quem mostra a primeira é o clique.
     */
}

});
